import { Component, OnChanges, EventEmitter } from '@angular/core';
import { filter } from 'rxjs/operators';
import { BaseComponent } from '../../shared/base-components/base.component';
import { ModalSize } from '../../shared/services/modal/mvd-modal.enum';
import { MvdModalService } from '../../shared/services/modal/mvd-modal.service';
import { CustomerCertification } from '../models/customer-certification.model';
import { CustomerCertificationType } from '../models/enums/customer-certification-type.enum';
import { CustomerManageService } from '../shared/customer-manage.service';
import { CertificationContext, CustomerCertificationModalComponent } from './customer-certification-modal.component';
import { HistoricalCertificationContext, HistoricalCustomerCertificationModalComponent } from './historical-customer-certification-modal.component';

@Component({
    selector: 'customer-certification',
    templateUrl: './customer-certification.html',
    inputs: ['customerNumber', 'certifications', 'canEdit'],
    outputs: ['onCertificationsChange']
})

export class CustomerCertificationComponent extends BaseComponent implements OnChanges {
    public certifications: CustomerCertification[];
    public customerNumber: number;
    public canEdit: boolean;
    public onCertificationsChange: EventEmitter<boolean> = new EventEmitter<boolean>();
    private certificationTypes = new CustomerCertificationType();

    constructor(
        public modalService: MvdModalService,
        private customerService: CustomerManageService) {
        super();
    }

    ngOnInit() {
        if (this.certifications !== undefined) {
            this.denormalizeData();
        } else if (this.customerNumber != null) {
            this.populateCertifications(this.customerNumber);
        }
    }

    ngOnChanges() {
        if (this.certifications !== undefined) {
            this.denormalizeData();
        } else if (this.customerNumber != null) {
            this.populateCertifications(this.customerNumber);
        }
    }

    populateCertifications(customerNumberId: number) {
        this.customerService.getCustomerCertifications(customerNumberId)
            .subscribe(result => {
                this.certifications = result;
            },
            e => console.log('error', e),
            () => {
                this.denormalizeData();
            });
    }

    denormalizeData() {
        for (const certification of this.certifications) {
            certification.certificationType = this.getValues(certification.customerCertificationTypeId, this.certificationTypes);
        }
    }

    getValues(id: number, types: any): string {
        if (id !== undefined && id !== null) {
            return types.FromId(id).displayValue;
        } else {
            return '';
        }
    }

    addCertification() {
        const data = new CertificationContext(0, this.customerNumber);
        this.modalService.open(CustomerCertificationModalComponent, data, ModalSize.Medium).afterClosed()
            .pipe(filter(result => !!result))
            .subscribe(() => {
                // this.populateCertifications(this.customerNumber);
                this.onCertificationsChange.emit(true);
            });
    }

    editCertification(id) {
        const data = new CertificationContext(id, this.customerNumber);
        this.modalService.open(CustomerCertificationModalComponent, data, ModalSize.Medium).afterClosed()
            .pipe(filter(result => !!result))
            .subscribe(() => {
                // this.populateCertifications(this.customerNumber);
                this.onCertificationsChange.emit(true);
            });
    }

    showHistory(id) {
        const data = new HistoricalCertificationContext(this.customerNumber);
        this.modalService.open(HistoricalCustomerCertificationModalComponent, data);
    }
}
